export const GET_RECIPE_REQUEST = "GET_RECIPE_REQUEST";
export const GET_RECIPE_SUCCESS = "GET_RECIPE_SUCCESS";
export const GET_RECIPE_FAILURE = "GET_RECIPE_FAILURE";


export const GET_SAVED_RECIPE_REQUEST = "GET_SAVED_RECIPE_REQUEST";
export const GET_SAVED_RECIPE_SUCCESS = "GET_SAVED_RECIPE_SUCCESS";
export const GET_SAVED_RECIPE_FAILURE = "GET_SAVED_RECIPE_FAILURE";

